import React from 'react';
import { translate } from 'react-i18next';
import * as Common from 'common/components';

const UsersTable = ({
  children,
  count = 0,
  company,
  subcompany,
  t = () => {},
//   order,
//   orderBy,
//   handleOrderChange,
}) => {
  const headers = [
    { variable: 'billNumber', text: t('acl.assetsBills.number') },
    { variable: 'billFolio', text: t('acl.assetsBills.folio')},
    { variable: 'billDate', text: t('acl.assetsBills.date')},
    { variable: 'billConcept', text: t('acl.assetsBills.concept')},
    { variable: 'billImport', text: t('acl.assetsBills.import')},
    { variable: 'billFile', text: t('acl.assetsBills.files')},
    ];

  const config = {
    // editPermission: 'acl.users.update',
    // togglePermission: 'acl.users.toggle',
    // editUrl: 'users', //Url para editar empleado
    propsName: '_bills', //de donde se obtienen los props
    // company: company,
    // subcompany: subcompany,
  };

  const dataCard = {
    rows: children,
    headers: headers,
    config: config,
    // handleClick: handleToggle,
  };

  return (
    <div className="table-responsive" style={{ position: 'relative' }}>
      <Common.List dataCard={dataCard}>
        {/* <table className="table table-hover table-striped"> */}
        <thead>
          <tr>
            <Common.ThSortable
            //   orderBy={orderBy}
            //   order={order}
              field="billNumber"
            //   handleOrderChange={handleOrderChange}
            >
              {t('acl.assetsBills.number')}
            </Common.ThSortable>
            <Common.ThSortable
            //   orderBy={orderBy}
            //   order={order}
              field="billFolio"
            //   handleOrderChange={handleOrderChange}
            >
              {t('acl.assetsBills.folio')}
            </Common.ThSortable>
            <Common.ThSortable
            //   orderBy={orderBy}
            //   order={order}
              field="billDate"
            //   handleOrderChange={handleOrderChange}
            >
              {t('acl.assetsBills.date')}
            </Common.ThSortable>
            <Common.ThSortable
            //   orderBy={orderBy}
            //   order={order}
              field="billConcept"
            //   handleOrderChange={handleOrderChange}
            >
                {t('acl.assetsBills.concept')}
            </Common.ThSortable>

            <Common.ThSortable
            //   orderBy={orderBy}
            //   order={order}
              field="billImport"
            //   handleOrderChange={handleOrderChange}
            >
                {t('acl.assetsBills.import')}
            </Common.ThSortable>      

            <Common.ThSortable
            //   orderBy={orderBy}
            //   order={order}
              field="billFile"
            //   handleOrderChange={handleOrderChange}
            >
                {t('acl.assetsBills.files')}
            </Common.ThSortable>         
          </tr>
        </thead>
        <tbody>
          {!count && <Common.EmptyTable colSpan={6} />}
          {children}
        </tbody>
      </Common.List>
      {/* </table> */}
      <Common.LoaderOverlay />
    </div>
  );
};

export default translate()(UsersTable);



// WEBPACK FOOTER //
// src/modules/secured/modules/assets/AssetsBillTable.js